export default __webpack_public_path__ + "static/media/erythree_carte_1-min.1c19af92.png";